import common from './api/common.js'

export default {
    common
}